import { useQuery } from "@tanstack/react-query";
import { API_URL_RETAILER_VALIDATE_ORDER } from "../../api";
import { retailerFetch } from "../../retailerFetch";
import { DocumentPrerequisiteStatusEnum } from "../../../../../models/external/ocmInterface";

export interface ValidationError {
    message: string;
    shouldPostToSlack: boolean;
    isTranslated: boolean;
    errorCode?: string;
}
export interface OrderValidationResult {
    collisionOrder?: {
        creationDate?: number;
        orderId: number;
        state?: DocumentPrerequisiteStatusEnum;
        salesAgent?: string;
    };
    currentOrderCreationDate?: number;
    validationPassed: boolean | null;
    errors: ValidationError[];
    orderState: string | null;
    orderRef?: string;
}

const fetchOrderValidation = async (): Promise<OrderValidationResult> => {
    const res = await retailerFetch(API_URL_RETAILER_VALIDATE_ORDER, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
    });
    if (!res.ok) {
        const json = await res.json().catch(() => ({}));
        throw new Error((json as { error?: string }).error ?? "Validering feilet");
    }
    return res.json() as Promise<OrderValidationResult>;
};

export const useOrderValidation = (enabled = true) => {
    return useQuery({
        queryKey: ["orderValidation"],
        queryFn: fetchOrderValidation,
        staleTime: 0,
        gcTime: 0,
        retry: false,
        enabled,
        refetchOnWindowFocus: false,
    });
};
